import { VscDebug } from 'react-icons/vsc'

import Panel from '~/components/Panel'
import { Checkbox, FormGroup } from '~/components/unform'
import { useAppInfo } from '~/hooks/useAppInfo'

export const DebugMode = () => {
  const { superAdmin } = useAppInfo()

  return superAdmin ? (
    <Panel
      iconLeft={<VscDebug />}
      title="Debug mode"
      isCollapsible
      initialCollapsibleState={false}
    >
      <FormGroup>
        <Checkbox name="debug" label="Ativar modo debug" />
        <hr />
        <p>
          Esse modo adiciona 3 novas informações no retorno:
          <ul>
            <li>
              <code>_es_queries</code> - As queries que foram executadas para
              montar os ads.
            </li>
            <li>
              <code>es_record</code> - Em cada Ad que representa o exato payload
              que o ElasticSearch retornou.
            </li>
            <li>
              <code>removed_by_adserver</code> - Irá no ad caso ele seja
              removido da requisição final pelo ad server. No momento só existe
              um motivo para isso: deduplicação de ads na requisição.
            </li>
          </ul>
        </p>
        <hr />
        <Checkbox name="api_staging" label="Ativar API staging" />
      </FormGroup>
    </Panel>
  ) : (
    <></>
  )
}
